module.exports = "/_next/static/images/blankmonitor-monotone-82b540bc2061af1d2f4778cbfe0fe360.svg";